import styled from 'styled-components';
import { media } from '../../utils';

export const Wrapper = styled.div`
	position: relative;
	height: var(--bannerHeight);
	display: grid;
	background: rgb(var(--bg) / 70%);
	overflow: hidden;

	.gatsby-image-wrapper {
		position: unset;
		overflow: hidden;
		grid-row: 1;
		grid-column: 1;
		max-height: var(--bannerHeight);

		img {
			object-position: center;
		}
	}

	.banner_content {
		color: var(--white);
		grid-row: 1;
		grid-column: 1;
		margin: 1rem;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		position: relative;

		${media.medium`
			margin: 2rem;
		`}
	}

	.banner_text {
		margin: 0 auto;
		max-width: 650px;
	}

	.title,
	.subtitle {
		margin: 0;

		${media.small`
			margin: 0 auto;
		`}
	}

	.title {
		line-height: 1.2;
	}

	.subtitle {
		font-size: var(--h3);
		font-family: var(--sans-serif);
		line-height: 1.2;
		margin-top: 0.5rem;

		${media.small`
			font-size: var(--h2);
		`};
	}

	.tagline {
		font-size: 1.2rem;
		font-style: italic;
		text-align: center;
		margin: 0;
		max-width: 600px;
	}

	.shades {
		display: contents;
		position: relative;
		grid-row: 1;
		grid-column: 1;
	}

	.shades > div {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;

		${media.small`
			
		`}
	}

	.shades > div:nth-child(1) {
		background-image: linear-gradient(
			0deg,
			rgba(0, 0, 0, 0.7) 35%,
			rgba(0, 0, 0, 0.59) 46.1%,
			rgba(0, 0, 0, 0.48) 55.6%,
			rgba(0, 0, 0, 0.37) 63.9%,
			rgba(0, 0, 0, 0.27) 71.3%,
			rgba(0, 0, 0, 0.18) 78.1%,
			rgba(0, 0, 0, 0.11) 84.4%,
			rgba(0, 0, 0, 0.06) 90.5%,
			rgba(0, 0, 0, 0.03) 100%
		);
	}

	.shades > div:nth-child(2) {
		background-image: linear-gradient(
			15deg,
			rgba(0, 0, 0, 0.7) 35%,
			rgba(0, 0, 0, 0.59) 46.1%,
			rgba(0, 0, 0, 0.48) 55.6%,
			rgba(0, 0, 0, 0.37) 63.9%,
			rgba(0, 0, 0, 0.27) 71.3%,
			rgba(0, 0, 0, 0.18) 78.1%,
			rgba(0, 0, 0, 0.11) 84.4%,
			rgba(0, 0, 0, 0.06) 90.5%,
			rgba(0, 0, 0, 0.03) 100%
		);
	}
`;
